import React from 'react';

import { SendOTPCodeModalContainer } from './send-otp-code/send-otp-code.modal.container';
import { EnterOTPCodeModalContainer } from './enter-otp-code/enter-otp-code.modal.container';
import { OpenExperienceModalContainer } from './open-experience/open-experience.modal.container';
import { useCSR } from './hooks/use-csr.hook';

type CSRContainerProps = {
  isCSRLoginStarted: boolean;
  memberPhone: string;
  onCSRLoginCancelled: () => void;
};

export const CSRContainer = ({
  isCSRLoginStarted,
  memberPhone,
  onCSRLoginCancelled,
}: CSRContainerProps) => {
  const {
    isSendOTPCodeModalOpen,
    isEnterOTPCodeModalOpen,
    isOpenExperienceAppAsMemberModalOpen,
    onSendOTPCodeModalHide,
    onEnterOTPCodeModalHide,
    onOpenExperienceModalHide,
    onSendOTPCodeCompleted,
    onEnterOTPCodeCompleted,
    session,
    smsURL,
    isOTPFlow,
  } = useCSR(isCSRLoginStarted, onCSRLoginCancelled);

  return (
    <>
      <SendOTPCodeModalContainer
        isOpen={isSendOTPCodeModalOpen}
        onHide={onSendOTPCodeModalHide}
        memberPhone={memberPhone}
        onCompleted={onSendOTPCodeCompleted}
      />
      <EnterOTPCodeModalContainer
        isOpen={isEnterOTPCodeModalOpen}
        onHide={onEnterOTPCodeModalHide}
        onCompleted={onEnterOTPCodeCompleted}
        session={session}
      />
      <OpenExperienceModalContainer
        isOpen={isOpenExperienceAppAsMemberModalOpen}
        onHide={onOpenExperienceModalHide}
        memberPhoneNumber={memberPhone}
        smsURL={smsURL}
        isOTPFlow={isOTPFlow}
      />
    </>
  );
};
